export const BLACK_FRIDAY_CAMPAIGNS = 'black-friday';
